// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_country from "../../commonapis/gen/buhta_common_v1_country.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_bic.ml",
  83,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Bic"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Dict"
    ]]
});

const Dict = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_bic.ml",
  132,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Bic"
          ]]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_bic.ml",
  179,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Bic"
    ]]
});

const Bic = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_bic.ml",
  218,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.dict.v1alpha1.Bic";
}

function make(countryOpt, codeOpt, nameOpt, full_nameOpt, effective_from, effective_until, keywordsOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const code = codeOpt !== undefined ? codeOpt : "";
  const name = nameOpt !== undefined ? nameOpt : "";
  const full_name = full_nameOpt !== undefined ? full_nameOpt : "";
  const keywords = keywordsOpt !== undefined ? keywordsOpt : "";
  return {
    country: country,
    code: code,
    name: name,
    full_name: full_name,
    effective_from: effective_from,
    effective_until: effective_until,
    keywords: keywords
  };
}

const merge_country = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "country",
    "country"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
]));

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "code",
    "code"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_full_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "full_name",
    "fullName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_effective_from = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "effective_from",
    "effectiveFrom"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_effective_until = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    7,
    "effective_until",
    "effectiveUntil"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

const merge_keywords = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    8,
    "keywords",
    "keywords"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge(t1, t2) {
  return {
    country: Curry._2(merge_country, t1.country, t2.country),
    code: Curry._2(merge_code, t1.code, t2.code),
    name: Curry._2(merge_name, t1.name, t2.name),
    full_name: Curry._2(merge_full_name, t1.full_name, t2.full_name),
    effective_from: Curry._2(merge_effective_from, t1.effective_from, t2.effective_from),
    effective_until: Curry._2(merge_effective_until, t1.effective_until, t2.effective_until),
    keywords: Curry._2(merge_keywords, t1.keywords, t2.keywords)
  };
}

function spec(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "country",
      "country"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
    Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "code",
      "code"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "full_name",
      "fullName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "effective_from",
      "effectiveFrom"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      7,
      "effective_until",
      "effectiveUntil"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let$1.name,
      make: $$let$1.make,
      from_proto: $$let$1.from_proto,
      from_proto_exn: $$let$1.from_proto_exn,
      to_proto: $$let$1.to_proto,
      to_proto$p: $$let$1.to_proto$p,
      merge: $$let$1.merge,
      to_json: $$let$1.to_json,
      from_json_exn: $$let$1.from_json_exn,
      from_json: $$let$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      8,
      "keywords",
      "keywords"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._8(serialize, writer, param.country, param.code, param.name, param.full_name, param.effective_from, param.effective_until, param.keywords);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(country, code, name, full_name, effective_from, effective_until, keywords) {
  return {
    country: country,
    code: code,
    name: name,
    full_name: full_name,
    effective_from: effective_from,
    effective_until: effective_until,
    keywords: keywords
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1alpha1.Bic", spec(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.country, param.code, param.name, param.full_name, param.effective_from, param.effective_until, param.keywords);
  };
}

function constructor$1(country, code, name, full_name, effective_from, effective_until, keywords) {
  return {
    country: country,
    code: code,
    name: name,
    full_name: full_name,
    effective_from: effective_from,
    effective_until: effective_until,
    keywords: keywords
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1alpha1.Bic", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, Bic, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "Bic"
    ]]
}, V1alpha1, {
  Bic: Bic
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "Bic"
          ]]
      },
      "V1alpha1"
    ]]
}, Dict, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "Bic"
                ]]
            },
            "V1alpha1"
          ]]
      },
      "Dict"
    ]]
}, Buhta, {
  Dict: Dict
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
